import React from "react";
import { SearchGlobalContext } from "@/components/Modals/SearchGlobalModal/utils";
import ListEmptyPlaceholder from "@jd/focus-desktop-comps/lib/es/ListEmptyPlaceholder";
import DataList from "@/components/Modals/SearchGlobalModal/DataList";
import { SearchType } from "@/services/SearchService";
import { ListItemClickFn } from "@/components/Modals/SearchGlobalModal/Tabs";
import lodashTrim from "lodash/trim";
import { ListItemData } from "@jd/focus-desktop-comps/lib/es/ListItem";
import { analysisLog } from "@/utils/logAnalytics";

export default function TabPaneYingyong({ onClick }: { onClick?: ListItemClickFn }) {
  const { keyword, t } = React.useContext(SearchGlobalContext);
  if (!lodashTrim(keyword)) {
    return <ListEmptyPlaceholder placeholder={t("search.emptyPlApps")} />;
  }
  return (
    <DataList
      searchType={SearchType.App}
      onClick={(data: ListItemData, index: number, pageSize: number) => {
        analysisLog("xtbg_home_search_1641454991771", "32");
        if (onClick) {
          onClick(SearchType.App, { ...data, pageSortNo: index, pageSize });
        }
      }}
    />
  );
}
